var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"vehicle-list"},_vm._l((_vm.categories),function(content,index){return _c('li',{key:index},[_c('video-box',{attrs:{"content":content}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }